/** Event colors map to the theme chart palette, so they adapt to dark mode. */
export const EVENT_COLORS = [
  "chart-1",
  "chart-2",
  "chart-3",
  "chart-4",
  "chart-5",
] as const;

export type EventColor = (typeof EVENT_COLORS)[number];

export const DEFAULT_EVENT_COLOR: EventColor = "chart-1";

export const getEventColorVar = (color?: string | null): string => {
  const safeColor = EVENT_COLORS.find((value) => value === color);
  return `var(--${safeColor ?? DEFAULT_EVENT_COLOR})`;
};
